import React from 'react';
import JoditEditor from 'jodit-react';
import { backend } from './apipath';

const HTMLEditor = (contents, name, callBack) => {
  // 從 localStorage 取 token（和你其他頁一致）
  let token = '';
  try {
    const auth = JSON.parse(localStorage.getItem('auth'));
    token = auth?.token || '';
  } catch (e) {}

  // 從多種回傳格式中「安全地」取出第一個圖片網址
  const pickUrl = (resp) => {
    if (!resp) return null;
    if (typeof resp === 'string') return resp;
    if (resp.url) return resp.url;
    if (resp.filePath) return resp.filePath;
    if (resp.file?.url) return resp.file.url;
    if (Array.isArray(resp.files) && resp.files.length > 0) return resp.files[0];
    // 有些後端包在 data
    if (resp.data) return pickUrl(resp.data);
    return null;
  };

  return (
    <JoditEditor
      value={contents}
      tabIndex={1}
      // name 不是 Jodit 的標準 props，但保留不影響
      name={name}
      config={{
        uploader: {
          insertImageAsBase64URI: false,
          url: `${backend}news/upload`,
          method: 'POST',
          // 後端期望的欄位名
          filesVariableName: () => 'file',
          // 帶上權限
          headers: token ? { token } : {},
          withCredentials: false,

          // 告訴 Jodit「這次算成功嗎」
          isSuccess: (resp) => {
            console.log('✅ isSuccess check:', resp);
            const url = pickUrl(resp);
            return !!url;
          },

          // 把後端回傳「整理成」Jodit 習慣的格式
          // 這裡統一回傳 { files: [url] }
          process: (resp) => {
            const url = pickUrl(resp);
            console.log('✅ process pick url:', url, 'resp:', resp);
            if (!url) {
              return { error: '無法取得圖片網址' };
            }
            return { files: [url] };
          },

          // 成功時插入圖片（支援一次多張）
          defaultHandlerSuccess: function (data) {
            // data = { files: [url, ...] }
            try {
              const files = Array.isArray(data?.files) ? data.files : [];
              if (!files.length) throw new Error('no files');
              files.forEach((url) => {
                const img = this.createInside.element('img');
                img.setAttribute('src', url);
                img.setAttribute('alt', '圖片');
                img.style.maxWidth = '100%';
                this.s.insertImage(img);
              });
            } catch (e) {
              console.error('插入圖片失敗：', e, data);
            }
          },

          // 失敗時
          defaultHandlerError: function (e) {
            console.error('❗ Jodit 預設錯誤處理：', e);
            const msg =
              e?.message ||
              e?.error ||
              e?.toString?.() ||
              '圖片上傳失敗，請稍後再試';
            this.events.fire('errorPopap', msg);
          },
        },

        events: {
          // Jodit 的全域錯誤監聽
          error: function (e) {
            console.error('❗ Jodit 錯誤事件：', e);
          },
        },

        language: 'zh_tw',
        height: 600,
      }}
      onChange={(newContent) => callBack(name, newContent)}
    />
  );
};

export default HTMLEditor;
